import { createSelector } from 'reselect';

const selectGlobalCatalog = (state: any) => state.globalCatalog;


export const selectGlobalCatalogCurrentItem = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.current);

export const selectGlobalCatalogListItems = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalCatalogListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalCatalogQueryItems = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.query);

export const selectGlobalCatalogCreatedItem = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.create);

export const selectGlobalCatalogUpdatedItem = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.update);

export const selectGlobalCatalogReadItem = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.read);

export const selectGlobalCatalogDeletedItem = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.delete);

export const selectGlobalCatalogSearchedItems = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.search);

export const selectGlobalCatalogItemsCount = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.count);

export const selectGlobalCatalogItemsFilter = createSelector([selectGlobalCatalog], (globalCatalog) => globalCatalog.filter);